export default "__VITE_ASSET__BPL6hWzR__"